import "./TransitTimes.scss";

export class BaseTransitTimes
{
	constructor()
	{
		this.Initialize();
	}

	public Initialize(): void
	{
	}
}